import { axiosInstance } from "@/axios/axiosInstance";
import { Activity } from "@/types/activity";
import { PaginatedResponse, QueryParamsBase } from "@/types/types";

export const getActivities = async (
  params?: QueryParamsBase & { select?: string[] },
): Promise<PaginatedResponse<Activity>> => {
  const { data } = await axiosInstance.get("/v2/activities", {
    params,
  });
  return data;
};
